if (!window.screen) {
    window.screen = {};
}
if (!window.screen.orientation) {
    window.screen.orientation = {};
}
if (!window.screen.orientation) {
    window.screen.orientation.type = getScreenOrientation();
}

function getScreenOrientation() {
    return window.innerHeight > window.innerWidth ? 'portrait' : 'landscape';
}
